import React from 'react';
import TabContent from './TabContent';

export const TabWithCardsContent = (props) => (<TabContent style={{ msFlexPack: 'distribute', justifyContent: 'space-evenly' }} {...props} />);



// WEBPACK FOOTER //
// ./src/react/containers/TabWithCardsContent.jsx